import {Base, model, endpoint, belongsTo, hasMany, getFrom} from '@scoutgg/ftw/source/lib/model'
import sources from '../../helpers/sources'

@model('SeasonSource')
@endpoint('season-sources', {root: '/api'})
@belongsTo('season')
@hasMany('matchSources')
@hasMany('teamSources')
@hasMany('playerSources')
@getFrom('season', ['league'])
export class SeasonSource extends Base {
  get sport() {
    const source = sources[this.source]
    return source && source.sport
  }
}
